import React from 'react';
import PropTypes from 'prop-types';
import { Body1 } from '@xo-union/tk-ui-typography';
import classnames from 'classnames';
import styles from './party-of-cell.scss';

class PartyOfCell extends React.Component {
  static propTypes = {
    value: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
  };

  render() {
    const { disabled = false } = this.props;

    return (
      <div
        className={classnames(styles.partyOfIcon, {
          [styles.disabledPartyOfIcon]: disabled,
        })}
      >
        <Body1 className={styles.partyOf}>{this.props.value}</Body1>
      </div>
    );
  }
}

export default PartyOfCell;
